import { render, staticRenderFns } from "./ModalDelete.vue?vue&type=template&id=6f2f5fb2&"
import script from "./ModalDelete.vue?vue&type=script&lang=js&"
export * from "./ModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports